<template>
    <div class="node-hover">
        <div
            :style="{ marginLeft: depth * 20 + 'px' }"
            class="d-flex justify-content-between align-items-center py-1"
        >
            <div class="d-flex align-items-center gap-1 cursor-pointer" @click="expanded = !expanded">
                <span v-html="expanded ? '&#9660;' : '&#9658;'"></span>
                <strong>{{ node.name }}</strong>
                <small v-if="node.code" class="text-muted ms-1">[{{ node.code }}]</small>
            </div>
            <button
                class="btn btn-sm btn-outline-danger"
                title="Remove group"
                @click="$emit('remove', node.id)"
            ><i class="fa fa-trash"></i></button>
        </div>

        <template v-if="expanded">
            <template v-for="child in childMap[node.id] || []" :key="child.id">
                <TemplateTreeNode
                    v-if="(child.group_level || 0) > 0"
                    :node="child"
                    :childMap="childMap"
                    :depth="depth + 1"
                    :expandAll="expandAll"
                    @remove="$emit('remove', $event)"
                />
                <div
                    v-else
                    :style="{ marginLeft: (depth + 1) * 20 + 'px' }"
                    class="d-flex justify-content-between align-items-center bg-black-light rounded-8 p-1 mb-1 mx-1"
                >
                    <span>
                        {{ child.name }}
                        <small v-if="child.code" class="text-muted ms-1">[{{ child.code }}]</small>
                    </span>
                    <button
                        class="btn btn-sm btn-outline-danger"
                        title="Remove endpoint"
                        @click="$emit('remove', child.id)"
                    ><i class="fa fa-trash"></i></button>
                </div>
            </template>
        </template>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    node:      { type: Object, required: true },
    childMap:  { type: Object, required: true },
    depth:     { type: Number, default: 0 },
    expandAll: { type: String, default: null },
});

defineEmits(['remove']);

const expanded = ref(false);

watch(() => props.expandAll, (val) => {
    if (!val) return;
    expanded.value = val.includes('expand');
});
</script>

<style scoped>
.bg-black-light { background: #00000024; }
.rounded-8     { border-radius: 8px; }
.node-hover:hover { background: #fffeec; }
.cursor-pointer   { cursor: pointer; }
</style>
